module.exports = __webpack_public_path__ + "curve.png?cb913c70362e2b9c5058d83b0dce48c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/curve.png
// module id = 32
// module chunks = 0